<template><div><h1 id="storno-erfassen" tabindex="-1"><a class="header-anchor" href="#storno-erfassen"><span>Storno erfassen</span></a></h1>
<p>Storno manuell erfassen — Buchungen stornieren</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Grundsätzlich können alle manuell erfassten Buchungstypen storniert werden. Eine Stornierung kann nicht mehr rückgängig gemacht werden. Beim Stornieren von Spenden oder Zusagenbbeiträgen werden gleichzeitig auch die dazugehörigen Zahlungen storniert. Bei Buchungen in Fremdwährungen wird der ursprüngliche Kurs der Buchung übernommen, unabhängig vom Stornodatum.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Buchhaltung → Manuelle Buchungen → Storno (Menü)</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Betrag</dt>
<dd>Betrag der Stornobuchung</dd>
<dt>Valutadatum</dt>
<dd>Buchungsdatum der Stornierung</dd>
<dt>Personen-ID</dt>
<dd>Adresse zu der die Debi-Note gebucht wird</dd>
<dt>Habenkonto</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.konti.html" title="Konti">Konto</a></dd>
<dt>Kostenstelle</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.kst.html" title="Kostenstellen">Kostenstelle</a></dd>
<dt>Kostenträger</dt>
<dd>Gem. Tabelle <a class="link" href="ft.refdata.ktr.html" title="Kostenträger">Kostenträger</a></dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>siehe oben</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>siehe oben</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.manbuch.html" title="Manuelle Buchung">Manuelle Buchungen</RouteLink></p>
</div></template>


